import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { handleThunkError } from "./handleThunkError";
import organizationsApi from "../api/organizationsApi.tsx";
import { OrganizationType } from "../types/organizationsTypes.tsx";
import { setNewCurrentOrganization } from "../slice/organizationsSlice.tsx";
import { deleteRevmaticsCookie } from "../../helpers/cookie/revmaticsCookies.ts";
import { getCookieName } from "../../helpers/cookieName/cookieName.ts";
import { RootState } from "../root.ts";

export const fetchOrganizationsList = createAsyncThunk(
  "organizations/fetchOrganizationsList",
  async (_, thunkAPI) => {
    try {
      const response: AxiosResponse<OrganizationType[]> =
        await organizationsApi.fetchOrganizationsList();
      const state = thunkAPI.getState() as RootState;
      const currentOrganization = state.organizations.currentOrganization;

      const isCurrentOrgValid = currentOrganization
        ? response.data.some(
            ({ keycloak_organization_id }) =>
              keycloak_organization_id === currentOrganization,
          )
        : false;

      if (!isCurrentOrgValid && currentOrganization) {
        thunkAPI.dispatch(setNewCurrentOrganization(null));
        deleteRevmaticsCookie(getCookieName.currentOrganization);
      }

      return response.data;
    } catch (e: unknown) {
      handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred.");
      return thunkAPI.rejectWithValue("Failed to fetch organizations.");
    }
  },
);
